import React, { useContext } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { LocationOn, Phone, Email } from "@mui/icons-material";
import { primaryColor,secondaryColor,fontFamilyAll } from "../../Util/UtilColor";
import FooterData from "../Footer/Footer";
import { useNavigate } from "react-router-dom";
import { KnowledgeBaseContext } from "../knowledgeBaseContext/KnowledgeBaseContext";
import { companyInfo, mediaData } from "../../Assets/data";

//f
export default function Footer({ footerData }) {
  const navigate=useNavigate();
    const {setSearchString}=useContext(KnowledgeBaseContext)

  return (
    <Box
      sx={{
        backgroundColor: secondaryColor,
        color: "white",
        py: 5,
        px: 5,
        // mt: 2,
        // borderRadius: "20px",
      }}
    >
      <Grid container spacing={4} justifyContent="space-between">
        {/* About Section */}
        <Grid item xs={12} md={1} mt={8}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <img
              src={companyInfo.logo}
              alt="Company Logo"
              style={{ width: 200, borderRadius: "15px" }}
            />
         
          </Box>
        </Grid>
  <Grid item xs={12} md={2} mt={4}>
             <Typography variant="body1" sx={{ opacity: 0.9 }} textAlign="justify"  fontFamily={fontFamilyAll}>
              {companyInfo.description}
            </Typography>
        </Grid>
        {/* Contact Info */}
        <Grid
          item
          xs={12}
          md={2}
          mt={4}
          sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
        >
          <Typography variant="h5" fontWeight="bold" fontFamily={fontFamilyAll}>Find Us</Typography>
          <Box mt={2}>
            <Typography display="flex" alignItems="center" gap={1} fontFamily={fontFamilyAll}>
              <LocationOn />
              <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(companyInfo.address)}`} 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 style={{ color: "white", textDecoration: "none" }}>
                {companyInfo.address}
              </a>
            </Typography>
            <Typography display="flex" alignItems="center" gap={1} mt={1} fontFamily={fontFamilyAll}>
              <Phone />
              <a href={`tel:${companyInfo.phone}`} 
                 style={{ color: "white", textDecoration: "none" }}>
                {companyInfo.phone}
              </a>
            </Typography>
            <Typography display="flex" alignItems="center" gap={1} mt={1} fontFamily={fontFamilyAll}>
              <Email />
              <a href={`mailto:${companyInfo.email}`} 
                 style={{ color: "white", textDecoration: "none" }}>
                {companyInfo.email}
              </a>
            </Typography>
          </Box>
        </Grid>
 <Grid item xs={12} md={2} mt={4}>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{
              color: "white",
              mb: 2,
              fontFamily: fontFamilyAll,
            }}
            textAlign={"left"}
          >
            Knowledge Base
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: fontFamilyAll,
              color: "white",
            }}
            textAlign={"justify"}
          >
        Stay up to date by exploring our range of articles and resources.{" "}
            
          <Typography
      variant="body1"
      sx={{ fontFamily: fontFamilyAll, color: "white", cursor: "pointer" , fontWeight:"bold"}}
      onClick={() =>{ navigate("/knowledgebase")
                      setSearchString("")

      }}  // 👈 navigate programmatically
    >
      View Knowledge Base →
    </Typography>
          </Typography>
        </Grid>
        {/* Social Media Links */}
        <Grid
          item
          xs={12}
          md={2}
          mt={4}
          sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
        >
          <Typography variant="h5" fontWeight="bold" fontFamily={fontFamilyAll}>Follow Us</Typography>
          <Box sx={{ display: "flex", mt: 2, gap: 2 }}>
            {mediaData.map(({ Icon, link }, index) => (
              <Box
                key={index}
                component="a"
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  cursor: "pointer",
                  fontSize: 40,
                  color: "#fff",
                  transition: "color 0.3s ease",
                  textDecoration: "none",
                  "&:hover": { color: "white" },
                }}
              >
                <Icon sx={{ fontSize: 40 }} />
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>

      {/* Footer Copyright Section */}
      <Box>
        <FooterData data={footerData} />
      </Box>
    </Box>
  );
}
